export const addressRoutes = {
  list: "",
  new: "new",
  edit: ":id/edit",
  bulkUpload: "import",
} as const;
